<ft-modal-editor-wrapper [canSave]="false" [theme]="theme" enterAnimation="none">
    <ng-template #triggerTmpl>
        <ng-content />
    </ng-template>
    <ft-monthly-daterange-picker [fromDate]="value?.startDate"
        [toDate]="value?.endDate"
        [fixedRangeDaysOverride]="fixedRangeDays"
        [theme]="theme"
        (changed)="onDateRangeChanged($event)"
        *ngIf="visible" />
</ft-modal-editor-wrapper>
